import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/quotes',
    name: 'quotes',
    meta: {
      title: 'Quotes'
    },
    component: () => import('@/views/quotes/QuoteListView.vue')
  },
  {
    path: '/quotes/:id',
    name: 'quote-detail',
    props: true,
    meta: {
      title: 'Quote'
    },
    component: () => import('@/views/quotes/QuoteDetailView.vue')
  }
]

export default routes
